import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PageHitDataService {

  private urlPageHit = environment.urlWebServices + '/cwk/pageHit';

  constructor(private http: HttpClient) { }

  // Create new page hit record
  create(data: any): Observable<any> {
    return this.http.post(`${this.urlPageHit}`, data);
  }
}
